import { ExpressionBlock } from './expression-block';
import { comparisonToLogicalString } from './expression-comparison';
import { fieldToLogicalString } from './expression-field';
import { ExpressionRule } from './expression-rule';
import { Filter } from './filter';

export class SearchFilterUtils {
  public static toLogicString(filter: Filter): string {
    return SearchFilterUtils.blockToLogicString(filter.block) || '()';
  }

  public static blockToLogicString(block?: ExpressionBlock): string {
    const rulesStringArray = (block?.rules || []).map(r =>
      SearchFilterUtils.ruleToLogicString(r)
    );
    const blocksStringArray = (block?.blocks || []).map(b =>
      SearchFilterUtils.blockToLogicString(b)
    );

    return (
      '(' +
      [...rulesStringArray, ...blocksStringArray].join(
        ` ${block?.operator} ` || ' ? '
      ) +
      ')'
    );
  }

  public static ruleToLogicString(rule?: ExpressionRule): string {
    const fieldString = fieldToLogicalString(rule?.field);
    const comparisonString = comparisonToLogicalString(rule?.comparison);
    const valueString = rule?.value || '?';

    return `${fieldString} ${comparisonString} ${valueString}`;
  }
}
